<!-- ApplicationListComponent.vue -->
<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back" data-testid="directions-32" @click="goBack()">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Applicant Details</ion-title>
  </ion-toolbar>
  <div class="main_wrapper ion-padding">
    <div v-if="initialIsLoading">
      <job-listing-skeleton :skeletonCount="1" />
    </div>
    <div v-else>
      <div class="applicant-person" data-testid="directions-1">
        <div class="image_wrapper" @click="userInfoModalOpen(application)">
          <el-avatar :size="'small'" shape="square" :src="application.image" v-if="application.image" />
          <el-avatar :size="'small'" class="avatar-job" shape="square"
            icon="locumate_icons locumate_icon-user1 locumate_icons-avatar" v-else></el-avatar>
        </div>
        <div class="applicant-info">
          <div class="applicant-main">
            <div class="wrapper-applicant">
              <div class="applicant-name">{{ application.applicantName }}</div>
              <div class="applicant-address mt-1">{{ application.address }}</div>

            </div>
            <div class="job-type-label-container">
              <div class="job-type-label">
                <a href="#" @click="goToChat()" class="chat-link rounded-action">
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1054_5446)">
                      <path
                        d="M6.49985 0.00150818C2.98728 -0.0677507 0.0806894 2.71773 0.000488281 6.23006C0.0096534 8.01797 0.801332 9.71222 2.16693 10.8663V12.7294C2.16693 12.879 2.28819 13.0002 2.43775 13.0002C2.4885 13.0002 2.53824 12.986 2.58127 12.9591L4.09075 12.0161C4.85981 12.3103 5.67647 12.4603 6.49985 12.4586C10.0124 12.5279 12.919 9.74241 12.9992 6.23008C12.919 2.71774 10.0124 -0.0677507 6.49985 0.00150818Z"
                        fill="#2196F3" />
                      <path
                        d="M10.7788 4.4425C10.6982 4.3345 10.5505 4.30218 10.4321 4.36666L7.61576 5.90214L5.86365 4.39969C5.75621 4.30758 5.59596 4.3137 5.49591 4.41378L2.24622 7.66347C2.14079 7.76954 2.14129 7.94101 2.24739 8.04645C2.33221 8.13076 2.46228 8.14944 2.56741 8.09242L5.38379 6.55695L7.13753 8.05993C7.24497 8.15203 7.40522 8.14592 7.50528 8.04584L10.755 4.79615C10.8497 4.70057 10.8598 4.54994 10.7788 4.4425Z"
                        fill="#FAFAFA" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1054_5446">
                        <rect width="13" height="13" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </div>
              <div class="job-type-label" :class="getClass(application.application_tag_status)"
              v-if="application.application_tag_status != ''">{{ application.application_tag_status }}</div>
            <div class="job-type-label" :class="application.type">{{ application.type }}</div>

            </div>
          </div>
          <div class="applicant-info-more">
            <ul>
              <li>
                <div class="job-info-icon">
                  <i class="el-icon-time"></i>

                </div>
                <div class="job-info-item">
                  Duration: <span>{{ application.experience }}</span>
                </div>
              </li>
              <li>
                <div class="job-info-icon">

                  <i class="locumate_icons locumate_icon-coin-dollar"></i>
                </div>
                <div class="job-info-item">Hourly Rate: <span>{{ application.hourlyRate }} Hourly</span></div>
              </li>
              <li>
                <div class="job-info-icon">
                  <i class="locumate_icons locumate_icon-coin-dollar"></i>
                </div>
                <div class="job-info-item">Annually Rate: <span>{{ application.annuallyRate }} Annually</span></div>
              </li>
            </ul>
          </div>
          <div>
            <div class="toggle">
              <div>
                <h4 class="job-applied-info-header">CV</h4>
                <div class="selected-cv-file" v-if="application.cv?.url">
                  <div class="cv-icon">
                    <img src="@/assets/img/default_pdf.svg" alt="" />
                  </div>
                  <div class="selected-cv-file-detail">
                    <div class="cv-title">
                      {{ application.cv.name }}
                    </div>
                    <div class="open-app-link">
                      <img src="@/assets/img/job-seeker/carbon_view.svg" height="16" alt="">
                      <a @click.prevent="openCvModal(application.cv)" href="#">View in the app</a>
                    </div>
                  </div>
                </div>

              </div>
              <div class="tagged-skills">
                <h4 class="job-applied-info-header">Skills</h4>
                <ul class="skill-tags">
                  <li v-for="skill in application.skills" :key="skill">{{ skill.name }}</li>
                </ul>
              </div>
              <div class="tagged-roles">
                <h4 class="job-applied-info-header">Roles</h4>
                <ul class="skill-tags">
                  <li v-for="item in application.role" :key="item">{{ item }}</li>
                </ul>
              </div>
            </div>
          </div>

        </div>
  
      </div>
      <div class="qa-details" v-if="application.questions.length > 0">
            <h4>
              Questions and Answers
            </h4>
            <div v-for="question in application.questions" :key="question.id">
              <p class="question">{{ question.question }}</p>
              <div v-if="question.type === 'file'">
                <div class="selected-cv-file-detail" v-if="question.fileUrl">
                    <div class="open-app-link">
                      <a @click.prevent="openFileAnswerModal(question.fileUrl)" href="#">
                        <div class="cv-icon">
                          <img src="@/assets/img/default_pdf.svg" alt="" />
                        </div>
                      </a>
                    </div>
                  </div>
                  <div class="img-thumbnail" v-else>
                    <img
                    class="el-upload-list__item-thumbnail"
                    :src="question.fileUrl"
                    alt=""
                  />
                  <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="docPreviewModalOpen(question.fileUrl)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>
                </span>
                  </div>
              </div>
              <div v-else>
                <p class="answer">{{ question.answer }}</p>
              </div>
            </div>
          </div>
      <div class="applied-for">
        <h1>Job Applied For:
        </h1>
        <div class="job-title">{{ application.title }}</div>
        <div v-html="application.description" class="rte-text">
        </div>
        <div class="job-applied">Published {{ application.applied }}</div>

      </div>
      <div class="secondary-button-group">
      <el-button class="categorize" size="sm" data-testid="directions-2"
        @click="openTriageDrawer(application)">{{ message.Categorize }}</el-button>
      <el-button class="notify-applicant" size="sm" data-testid="directions-2"
        @click="awardApplicant(application)">Notify Applicant</el-button>
      
    </div>
    </div>
  </div>
  <el-drawer custom-class="bottom_drop_up" v-model="bottomDropUp" :append-to-body="true" :with-header="false"
    :direction="'btt'" :destroy-on-close="true">
    <div class="category-select-radio-group">
      <div class="label-text">Select</div>
      <el-radio-group v-model="selectedCategory" @change="handleRadioChange">
        <el-radio :label="category.jobApplicantCategory" v-for="category in applicantStatusCategories" :key="category.id">{{
    category.jobApplicantCategory }}</el-radio>
      </el-radio-group>
    </div>
  </el-drawer>
  <JobApplicantInfoModal :modalName="'userInfoModal'" :options="userInfoModal" />
  <PreviewModal
    :modalName="'previewModal'"
    :options="previewModal"
  />
  <el-dialog title="CV Preview" v-model="modalVisible" width="50%" :close-on-click-modal="true" @close="closeCvModal">
    <vue-pdf-embed :source="selectedCv.url" />
  </el-dialog>
  <el-dialog title="CV Preview" v-model="modalFileAnswerVisible" width="50%" :close-on-click-modal="true" @close="closeFileAnswerModal">
    <vue-pdf-embed :source="selectedFileAnswer" />
  </el-dialog>
</template>

<script setup>
import { onMounted, ref, reactive, inject,onBeforeMount } from "vue";
import JobListingSkeleton from "@/components/JobListingSkeleton/JobListingSkeleton.vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { JobApplicantInfoModal, PreviewModal } from "@/modals/modals";
import VuePdfEmbed from 'vue-pdf-embed';
import { ElMessageBox, ElMessage } from "@/components/Vendor/Element";


const router = useRouter();
const route = useRoute();
const $store = useStore();
const initialIsLoading = ref(true);
const store = useStore();
const bottomDropUp = ref(false);
const selectedCategory = ref(null);
const application = reactive({});
const $modals = inject("$modals");
const selectedApplicant = ref(null);
const applicantStatusCategories = ref([]);
const message = inject("messages");
// const $router = useRouter();

const userInfoModal = ref({
  name: "userInfo",
  application: {},
});
const userData = store.getters.GET_USER_DATA;
const selectedCv = ref(null);
const modalVisible = ref(false);

const selectedFileAnswer = ref(null);
const modalFileAnswerVisible = ref(false);

onMounted(() => {
  fetchApplication();
});

const previewModal = ref({
      name: "insuranceDocument",
      file: [],
    });
    const docPreviewModalOpen = (file) => {
      const construct = {url: file};
      previewModal.value.file = construct;
      $modals.open("previewModal", {
        file: construct,
      });
    };

const goBack = () => {
  console.log("back");
  router.push({
        name: "job_poster",
      });
};


const getClass = (status) => {
      // Convert the status to lowercase for case-insensitive comparison
      const lowercaseStatus = status.toLowerCase();

      // Return class based on status
      return lowercaseStatus;
    };
const openTriageDrawer = (application) => {
      selectedApplicant.value = application;
      bottomDropUp.value = true
    };

    const awardApplicant = async (application) => {

try {
  await ElMessageBox.confirm(
    `Are you sure you want to award this job to ${application.applicantName}?`,
    "Award Job",
    {
      confirmButtonText: "Award",
      cancelButtonText: "Cancel",
      confirmButtonClass: "el-button--primary",
      cancelButtonClass: "el-button--grey",
      showClose: false,
    }
  );

  await (async () => {
    try {
      const response = await $store.dispatch("BULK_NOTIFY_SEEKER", {
        applicationIds: [application.id],
      });

      if (response.data.success) {
        ElMessage({
          type: "success",
          message: response.data.message,
        });
        // instance.emit('refresh-applicants-list');
     
      } else {
        ElMessage({
          type: "info",
          message: response.data.message,
        });
      }

      // currentRouteName.value = $router.currentRoute.value.name;
      // console.log("🚀 ~ await ~ currentRouteName.value:", currentRouteName.value)
      // $store.dispatch('PREVIOUS_ROUTE_NAME', currentRouteName.value);

      router.push({
        name: "job_poster",
      });

    } catch (error) {
      ElMessage({
        type: "error",
        message: error.message,
      });
    }
  })();
} catch (error) {
  console.log(error);
}
}
const userInfoModalOpen = (application) => {
  if (application) {
    userInfoModal.value.user = application;
  }
  $modals.open("userInfoModal");
};
const openCvModal = (cv) => {
  console.log("🚀 ~ openCvModal ~ cv:", cv)

  // Set the file URL to be displayed in the modal
  selectedCv.value = cv;
  // Show the modal
  modalVisible.value = true;
};
const closeCvModal = () => {
  modalVisible.value = false;
};

const openFileAnswerModal = (url) => {
  console.log("🚀 ~ openAnswwerModal ~ cv:", url)

  // Set the file URL to be displayed in the modal
  selectedFileAnswer.value = url;
  // Show the modal
  modalFileAnswerVisible.value = true;
};
const closeFileAnswerModal = () => {
  modalVisible.value = false;
};

const goToChat = () => {
  router.push({
    name: "chat_message",
    params: {
      chatId: userData.id + "." + application.applicantId,
    },
  });
};

onBeforeMount(async () => {
      try {
        const applicantStatusCategoriesResponse = await $store.dispatch("GET_JOB_APPLICANT_STATUS_CATEGORIES");
        applicantStatusCategories.value = applicantStatusCategoriesResponse.data;
      } catch (error) {
        console.error("Error occurred:", error);
      }
    });

    const handleRadioChange = async (selectedStatus) => {

await ElMessageBox.confirm(
  `Are you sure you want update the status of the applicant?`,
  "Update status",
  {
    confirmButtonText: "Update",
    cancelButtonText: "Cancel",
    confirmButtonClass: "el-button--primary",
    cancelButtonClass: "el-button--grey",
    showClose: false,
  }
);

await (async () => {
  try {
    const applicantStatusCategoriesResponse = await $store.dispatch("UPDATE_JOB_APPLICANT_STATUS_CATEGORY", {
      applicationId: selectedApplicant.value.id,
      payload: {
        status: selectedStatus
      }
    });

    console.log(applicantStatusCategoriesResponse);

    if (applicantStatusCategoriesResponse.data.success) {
      ElMessage({
        type: "success",
        message: applicantStatusCategoriesResponse.data.message,
      });

    } else {
      ElMessage({
        type: "info",
        message: applicantStatusCategoriesResponse.data.message,
      });
    }

    bottomDropUp.value = false;

  } catch (error) {
    ElMessage({
      type: "error",
      message: error.status[0],
    });
    console.log('hellooo');
  }
})();
}

const fetchApplication = async () => {
  try {
    const response = await store.dispatch('GET_JOB_APPLICANT_DETAIL', {
      applicationId: route.params.applicationId
    });
    const applicationData = response.data;
    Object.assign(application, {
      id: applicationData.id,
      applicantId: applicationData.applicant.id,
      applicantName: applicationData.applicant.name,
      image: applicationData.applicant.image,
      role: applicationData.applicant.role,
      address: applicationData.applicant.address,
      experience: applicationData.applicant.experience,
      hourlyRate: applicationData.applicant.salaryExpectationHourly,
      annuallyRate: applicationData.applicant.salaryExpectationAnnually,
      cv: applicationData.cv,
      skills: applicationData.applicant.skills,
      result: true,
      title: applicationData.jobPost.title,
      poster: applicationData.jobPost.pharmacy.name,
      shortDescription: applicationData.jobPost.shortDescription,
      type: applicationData.jobPost.type,
      applied: applicationData.appliedAgo,
      jobPostId: applicationData.jobPost.id,
      application_tag_status: applicationData.applicationTagStatus,
      description: applicationData.jobPost.description,
      questions: applicationData.questions?applicationData.questions:[],
    });

    initialIsLoading.value = false;
  } catch (error) {
    console.error(error);
  }

  
};
</script>
